import { Shape }                from '@tokamap/core';
import PlaceModel               from '@models/map/PlaceModel';
import currentEditorStore       from '@/TokamapEditor/stores/currentEditorStore';
import { fetchEntityFromPlace } from '@/TokamapEditor/stores/EditorMercureListener';
import shapePlaceId             from '@/TokamapEditor/helpers/shapePlaceId';
import { PLACE_IMAGE_SOURCE }   from '@/TokamapEditor/helpers/placeLinkedContent';

export default async function relinkPlaceImage(shape: Shape) {
	const placeId = shapePlaceId(shape);

	if (!placeId) return;

	const place = new PlaceModel({ id: placeId });
	await place.fetch();

	const entity = await fetchEntityFromPlace(place, false);
	const editor = currentEditorStore.get;

	editor.setShapeEntity(shape.id, entity, { skipHistory: true, skipSave: true, skipConfirm: true });
	await editor.setShapeImage(shape.id, { src: entity.entity.image || '', source: PLACE_IMAGE_SOURCE });
}
